import { FormHelperText, FormHelperTextProps } from '@mui/material'
import React from 'react'

export type WcFormHelperTextProps = FormHelperTextProps

export const WcFormHelperText = ({children, ...props}: WcFormHelperTextProps) => (
    <FormHelperText {...props}>{children}</FormHelperText>
  )

